import {
    Divider,
    Grid,
    IconButton,
    Tooltip,
    Typography,
} from "@mui/material";
import { useState } from "react";

import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import CancelIcon from '@mui/icons-material/Cancel';
import ApprovalIcon from '@mui/icons-material/Approval';

const EnquiryComparisionSubMenu = ({
    selectedButtonName,
    setSelectedButtonName,
    handlecallProcess,

    visibleSaveBtn,
    visibleApproveButton,
    visibleGeneratePOButton,

    handleSave,
    handleApprove,
    generatePOs
}) => {

    const [selectedButton, setSelectedButton] = useState(null);

    const handleButtonClick = (buttonName) => {
        setSelectedButton(buttonName);
        setSelectedButtonName(buttonName);
        handlecallProcess(buttonName);
    };

    const getColor = (btn) =>
        selectedButton === btn ? "yellow" : "#009688";

    return (
        <Grid container alignItems="center" padding={0}>



            {/* <Divider orientation="vertical" flexItem sx={{ mx: 1 }} /> */}

            {/* Clear */}
            {/* <Grid item>
                <Tooltip title="Clear all fields">
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <IconButton onClick={() => handleButtonClick("Clear")}>
                            <CancelIcon style={{ fontSize: 20, color: getColor("Clear") }} />
                            <Typography variant="h6" sx={{ ml: 1 }}>
                                Clear
                            </Typography>
                        </IconButton>
                    </div>
                </Tooltip>
            </Grid> */}


            {/* ---------------------------------------------- */}
            {/* NOW ADD YOUR MAIN PAGE BUTTONS HERE */}
            {/* ---------------------------------------------- */}
          

            {/* Save Button */}
            {/* {visibleSaveBtn && (
                <Grid item>
                    <Tooltip title="Save">
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <IconButton onClick={handleSave}>
                                <SaveAltIcon style={{ fontSize: 20, color: getColor("mainSave") }} />
                                <Typography variant="h6" sx={{ ml: 1 }}>
                                    Save
                                </Typography>
                            </IconButton>
                        </div>
                    </Tooltip>
                </Grid>
            )} */}

            {/* Approve Button */}
            {visibleApproveButton && (
                <>
                    
                    <Grid item>
                        <Tooltip title="Approve">
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <IconButton onClick={handleApprove}>
                                    <ApprovalIcon style={{ fontSize: 20, color: getColor("Approve") }} />
                                    <Typography variant="h6" sx={{ ml: 1 }}>
                                        Approve
                                    </Typography>
                                </IconButton>
                            </div>
                        </Tooltip>
                    </Grid>

                     <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                </>
            )}

            {/* Generate PO Preview */}
            {visibleGeneratePOButton && (
                <>
                    
                    <Grid item>
                        <Tooltip title="Generate Purchase Order Preview">
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <IconButton onClick={generatePOs}>
                                    <AddCircleOutlinedIcon style={{ fontSize: 20, color: getColor("POPreview") }} />
                                    <Typography variant="h6" sx={{ ml: 1 }}>
                                        PO Preview
                                    </Typography>
                                </IconButton>
                            </div>
                        </Tooltip>
                    </Grid>
                    <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                </>
            )}

        </Grid>
    );
};

export default EnquiryComparisionSubMenu;
